import React, { FC, useEffect, useState } from 'react';
import { Popup } from '../../../../components';
import { barlines, qInfo } from '../../icons';
import { ReactComponent as Triangle } from '../../icons/triangle_icon.svg';
import GetColorAndMessage from './getColorAndMessage';
import InfobarsSkeleton from '../skeletons/InfobarsSkeleton';

interface AnimatematedInfoBarProps {
  title: string;
  min: number;
  max: number;
  current: number;
  popupMessage?: string;
  animationTime: number;
  isLoading: boolean;
  skelTitleWidth: number;
}

const AnimatematedInfoBar: FC<AnimatematedInfoBarProps> = (props) => {
  const {
    min,
    max,
    title,
    popupMessage,
    animationTime,
    isLoading,
    skelTitleWidth,
    current,
  } = props;

  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [color, setColor] = useState('#c5c5cc');
  const [measure, setMeasure] = useState(NaN);

  const maxPosssibleVal = max - min;
  const fullValue = current - min;

  useEffect(() => {
    setColor('#c5c5cc');
    setMeasure(NaN);
    const barsTimer = setTimeout(() => {
      if (!Number.isNaN(current) && current !== undefined) {
        const { triangeColor } = GetColorAndMessage(current, title);
        setColor(triangeColor);
        setMeasure((fullValue / maxPosssibleVal) * 100);
      }
    }, 200);
    return () => {
      clearTimeout(barsTimer);
    };
  }, [current]); // eslint-disable-line

  const animationTimeCondition: number = animationTime > 2 ? animationTime : 2;

  const triangleColorCondiditon =
    Number.isNaN(current) || current !== undefined;

  return (
    <div className="barwrapper">
      <InfobarsSkeleton
        skelTitleWidth={skelTitleWidth}
        duration={2200}
        globalLoading={isLoading}
      >
        <>
          <div className="barwrapper-title">
            {title}{' '}
            <div className="barwrapper-title-iconBlock">
              <img
                src={qInfo}
                alt="info"
                onClick={() => setPopupIsOpen(true)}
                onMouseEnter={() => setPopupIsOpen(true)}
                onMouseLeave={() => setPopupIsOpen(false)}
              />
              <Popup
                open={popupIsOpen}
                className="barwrapper-title-iconBlock-popup"
                text={popupMessage}
              />
            </div>
          </div>
          {Number.isNaN(current) || current === undefined ? (
            <>
              <div className="barwrapper__barblock-bar">
                <div className="barwrapper__barblock-bar-grey" />
                <img
                  className="barwrapper__barblock-bar-lines"
                  src={barlines}
                  alt="lines"
                />
              </div>
            </>
          ) : (
            <div className="barwrapper__barblock">
              {title === 'subtleness' ? (
                <></>
              ) : (
                <div
                  className="barwrapper__barblock-triangle"
                  style={{
                    left: `${measure}%`,
                    transitionDuration: `${animationTimeCondition}s`,
                    transitionTimingFunction: 'ease',
                  }}
                >
                  <Triangle
                    fill={triangleColorCondiditon ? color : '#c5c5cc'}
                    className="barwrapper__barblock-triangle-color"
                  />
                </div>
              )}
              <div className="barwrapper__barblock-bar">
                <div className="barwrapper__barblock-bar-gradient" />
                <img
                  className="barwrapper__barblock-bar-lines"
                  src={barlines}
                  alt="lines"
                />
              </div>
            </div>
          )}

          <div className="barwrapper-footer">
            {title === 'responsiveness' ? ( //eslint-disable-line
              <>
                <span className="barwrapper-footer__text">SLOW</span>
                <span className="barwrapper-footer__text">FAST</span>
              </>
            ) : title === 'subtleness' ? (
              <>
                <span className="barwrapper-footer__text">LOW</span>
                <span className="barwrapper-footer__coming-soon">
                  coming soon
                </span>
                <span className="barwrapper-footer__text">HIGH</span>
              </>
            ) : (
              <>
                <span className="barwrapper-footer__text">LOW</span>
                <span className="barwrapper-footer__text">HIGH</span>
              </>
            )}
          </div>
        </>
      </InfobarsSkeleton>
    </div>
  );
};

export default AnimatematedInfoBar;
